export default "__VITE_ASSET__jJ8J1a0e__";